import type { TrendData } from "../hooks/useRankingTrends";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/outline";

interface TrendIndicatorProps {
  trend: TrendData | null;
  showPercentage?: boolean;
  size?: "sm" | "md";
}

const TrendIndicator = ({ trend, showPercentage = true, size = "sm" }: TrendIndicatorProps) => {
  if (!trend) {
    return <span className="text-gray-400">-</span>;
  }

  const { value, isPositive } = trend;

  const colorClass = isPositive ? "text-green-600" : "text-red-600";
  const bgColorClass = isPositive ? "bg-green-50" : "bg-red-50";
  const sizeClass = size === "sm" ? "text-xs" : "text-sm";

  const ArrowIcon = isPositive ? (
    <ChevronUpIcon className={size === "sm" ? "h-3 w-3" : "h-4 w-4"} strokeWidth={2} />
  ) : (
    <ChevronDownIcon className={size === "sm" ? "h-3 w-3" : "h-4 w-4"} strokeWidth={2} />
  );

  return (
    <span
      className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded ${bgColorClass} ${colorClass} ${sizeClass} font-medium`}
    >
      {ArrowIcon}
      {showPercentage && <span>{value}%</span>}
    </span>
  );
};

export default TrendIndicator;
